import script from "./CtaBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaBtn.vue?vue&type=script&setup=true&lang=js"

import "./CtaBtn.vue?vue&type=style&index=0&id=aab291c6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aab291c6"]])

export default __exports__